import React from 'react';
import { AtSignIcon, GlobeIcon, MailIcon } from 'lucide-react';
import { BRAND, FOOTER_LINE, TAGLINE, footerLinks } from '../data/eatWellContent';
export function Footer() {
  return <footer className="w-full border-t border-charcoal-600 bg-charcoal-900 py-14" data-id="element-84" data-mp="32o4deh7i4k9p">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-85" data-mp="32m1ef7odfgsu">
        <p className="font-display text-2xl font-semibold uppercase tracking-[0.14em] text-ivory-50" data-id="element-86" data-mp="36pzblcu4yhj9">
          {BRAND}
        </p>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-body" data-id="element-87" data-mp="3ud7gvurkdqla">
          {FOOTER_LINE}
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-body" data-id="element-88" data-mp="3lelzw41qqjmm">
          <li className="flex items-center gap-1.5" data-id="element-89" data-mp="3qcx8kbgauo39">
            <MailIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-90" data-mp="3qfjiuiukrhp6" />
            <a href={`mailto:${footerLinks.email}`} className="transition-colors duration-150 ease-out hover:text-champagne" data-id="element-91" data-mp="2a19vns22jyzx">
              {footerLinks.email}
            </a>
          </li>
          <li className="flex items-center gap-1.5" data-id="element-92" data-mp="3gapcti26iifg">
            <AtSignIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-93" data-mp="3gca859wbi5ed" />
            {footerLinks.social}
          </li>
          <li className="flex items-center gap-1.5" data-id="element-94" data-mp="3q83u1jvxfb8t">
            <GlobeIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-95" data-mp="3q7bz8ba5lhjl" />
            {footerLinks.website}
          </li>
        </ul>

        <div className="mt-10 border-t border-charcoal-600 pt-8" data-id="element-96" data-mp="32w27regl89q">
          <p className="text-[13px] leading-relaxed text-muted" data-id="element-97" data-mp="hsk3ismn46xg">
            © Redondoland™ 2024 — All rights reserved. Reproduction and redistribution
            prohibited without express authorization.
          </p>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-champagne" data-id="element-98" data-mp="qsqdi4j4qorv">
            “{TAGLINE}”
          </p>
        </div>
      </div>
    </footer>;
}